import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import Btn from 'components/Btn'

export default withTranslation()(function CreditAccountCard({ t, onTopUp }) {
  return (
    <div className="w-full flex-1 bg-background border border-border-lines rounded-2xl p-4 flex flex-col gap-6">
      <div className="flex items-start gap-3.5">
        <span className="w-12 h-12 rounded-full bg-focus border border-border-lines flex items-center justify-center shrink-0">
          <UIcons.UilWallet className="text-primary" size={24} />
        </span>

        <div className="flex-1">
          <p className="text-base font-semibold text-dark-blue">{t('billing.credit_account.title')}</p>
          <p className="text-xs text-secondary">{t('billing.credit_account.description')}</p>
        </div>

        <Btn
          content={() => <span className="flex items-center gap-2"><UIcons.UilPlus size={16} /> {t('billing.credit_account.top_up')}</span>}
          className="text-white bg-primary rounded-full h-9 px-4 font-semibold text-sm whitespace-nowrap"
          click={onTopUp}
        />
      </div>

      <div>
        <p className="text-2xl font-semibold text-dark-blue">GHS 18,450.60</p>
        <p className="text-xs font-semibold text-success uppercase">{t('billing.credit_account.available_balance')}</p>
      </div>

      <div className="flex items-center">
        <div className="flex-1 border-r border-dashed border-border-lines pr-4">
          <p className="text-xs font-semibold text-secondary uppercase whitespace-nowrap">{t('billing.credit_account.total_funded')}</p>
          <p className="text-base text-dark-blue">GHS 50,000</p>
        </div>

        <div className="flex-1 border-r border-dashed border-border-lines px-4">
          <p className="text-xs font-semibold text-secondary uppercase whitespace-nowrap">{t('billing.credit_account.used_this_month')}</p>
          <p className="text-base text-dark-blue">GHS 50,000</p>
        </div>

        <div className="flex-1 px-4">
          <p className="text-xs font-semibold text-secondary uppercase whitespace-nowrap">{t('billing.credit_account.low_balance_alert')}</p>
          <p className="text-base text-dark-blue">20%</p>
        </div>
      </div>
    </div>
  )
})
